type Reporter = { addError: (error: Error) => void };

let reporter: Reporter | undefined;

export const setReporter = (next: Reporter): void => {
  reporter = next;
};

export const reportError = (error: Error): void => {
  reporter?.addError(error);
};
